export default __webpack_public_path__ + "static/media/gallery_01.4e6478c0.jpg";